"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const ErrorBannerContainer = styled_components_1.default.div `
  border: solid 1px ${tokens.ColorFunctionalRed500};
  background: #fbe9e8 url(data:image/svg+xml;base64,${tokens.AssetIconError}) no-repeat 16px 16px;
  padding: 16px 16px 16px 56px;
  margin: 16px 0;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: ${tokens.ColorGrey900};
  @media (max-width: 768px) {
    margin: 24px 0 16px;
  }
`;
class ErrorBanner extends react_1.Component {
    render() {
        const { message, children } = this.props;
        return (react_1.default.createElement(ErrorBannerContainer, { tabIndex: 0 },
            children ? children : message ? message : "",
            " "));
    }
}
exports.default = ErrorBanner;
//# sourceMappingURL=ErrorBanner.js.map